import axios from "axios";

class EverestRepository {
  
  doLogin = (params, callback, errorCallback) => {
    axios.post(`/oauth/token?grant_type=password&username=${params.username}&password=${params.password}`, {}, {
      headers: {
        Authorization: "basic YXNwaXJpbi1jbGllbnQ6YXNwaXJpbi1zZWNyZXQ=",
        ContentType: "application/x-www-form-urlencoded",
      }
    }).then((res) => {
      if (res && res.status === 200) {
        callback && callback(res.data);
      } else {
        errorCallback && errorCallback(res);
      }
    });
  }

  findMe = (params = {}, callback) => {
    axios.get("/v1/api/everest/users/me")
      .then((res) => {
        if (res && res.status === 200)
          callback && callback(res.data);
      });
  }
}

export { EverestRepository };
